import {Component, OnInit} from '@angular/core';
import {HttpClient} from "@angular/common/http";
import {debounceTime, distinctUntilChanged, map, tap} from "rxjs/operators";
import { Observable, Subject, Subscription } from 'rxjs';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit {
  title = 'JoyFlix';
  movieList!: Array<any>;
  pageNumber: number = 1;
  pages: Array<number> = [];
  pageLength!: number;
  totalResults!: number;
  promise!: Promise<any>;
  selectedMovie: any;
  selectedId!: string;
  searchString: any;
  searchTerm$ = new Subject<string>();
  subscriptions = new Subscription();

  constructor(private http: HttpClient) {
    this.subscriptions.add(this.search(this.searchTerm$).subscribe(() => {
      console.log('searchTerm');
      this.searchMovie();
    }));
  }

  get(page: number) {
    return this.http.get(`https://www.omdbapi.com/?&apikey=e7cf91bb&type=movie&page=${page}&s=${this.searchString ? this.searchString : 'batman'}`).pipe(map(res => res));
  }

  getList(pageNumber: number) {
    this.promise = new Promise(async (resolve, reject) => {
      this.get(pageNumber).subscribe((res: any) => {
        console.log('res', res);  
        if (res) {
          resolve(res);
          this.movieList = res.Search;
          this.totalResults = res.totalResults;
          this.selectedId = this.movieList[0].imdbID;
          this.selectMovie(this.movieList[0].imdbID);
        }          
      });
    });    
  }

  initList() {
    this.getList(this.pageNumber);
    this.promise.then((res)=> {
      this.getPage(res);
      this.selectedId = this.movieList[0].imdbID;
      this.selectMovie(this.movieList[0].imdbID);
    }).catch((error)=> {});
  }

  getPage(res: any) {
    const totalPages = res.totalResults;
    for (let i = 0; i < totalPages; i++) {
      this.pages.push(i + 1);
    }
    this.pageLength = this.pages.length;
    console.log('pagessss', this.pages);
  }

  getMovieSingle(id: string) {
    return this.http.get(`https://www.omdbapi.com/?&apikey=e7cf91bb&type=movie&i=${id}&plot=full`).pipe(map(res => res));
  }

  selectMovie(id: string) {
    console.log('select');
    this.selectedId = id;
    this.getMovieSingle(id).subscribe(res => {
      console.log('selected movie', res);
      this.selectedMovie = res;
    })
  }

  search(terms: Observable<string>) {
    return terms
    .pipe(
      debounceTime(500),
      distinctUntilChanged()
    );
  }

  searchMovie() {
    this.http.get(`https://www.omdbapi.com/?&apikey=e7cf91bb&type=movie&s=${this.searchString ? this.searchString : 'batman'}`).pipe(map(res => res)).subscribe((res: any) => {
      console.log('search movie', res);
      this.movieList = res.Search;
      this.totalResults = res.totalResults;
    });
  }

  selectPage($event: any) {
    this.getList($event);
    console.log('selectPage', $event);
  }

  getPercentage(rating: any) {
    return rating ? (rating * 10) : null;
  }

  watch(title: any) {
    window.open(`https://www.vudu.com/content/movies/search?minVisible=0&searchString=${title}`, '_blank');
  }
  
  ngOnInit(): void {
    this.initList();
  }
}
